import React from 'react';
import { cn } from '@/lib/utils';
import { snakeToTitleCase } from '@/modules/shared/utils';
import { STATUS_PILL_CLASSES, STATUS_PILL_VARIANTS, TAG_KEYS } from '../constants';
import type { GlobalSearchHit } from '../types';
import HighlightedText from './HighlightedText';

const formatPlain = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '-';
  return snakeToTitleCase(String(value));
};

/**
 * Renders one hit field: status keys become colored pills; other values prefer
 * the highlight fragment (matched term emphasized), falling back to the raw
 * value title-cased, then '-'.
 */
const FieldValue: React.FC<{ hit: GlobalSearchHit; fieldKey: string }> = ({ hit, fieldKey }) => {
  const rawValue = hit[fieldKey];

  if (TAG_KEYS.includes(fieldKey) && typeof rawValue === 'string' && rawValue) {
    const variant = STATUS_PILL_VARIANTS[rawValue] ?? 'orange';
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
          STATUS_PILL_CLASSES[variant],
        )}
      >
        {snakeToTitleCase(rawValue)}
      </span>
    );
  }

  const fragment = hit.highlight?.[fieldKey]?.[0];
  if (fragment) return <HighlightedText text={fragment} />;

  return <>{formatPlain(rawValue)}</>;
};

export default FieldValue;
